import PropTypes from "prop-types";
import { DirectionalIcon } from "../DirectionalIcon/DirectionalIcon";
import NoCamera from "~/content/icons/no-camera.svg?react";

export function NoCameraIcon({ className }) {
  return (
    <DirectionalIcon>
      <NoCamera className={className} />
    </DirectionalIcon>
  );
}

NoCameraIcon.propTypes = {
  className: PropTypes.string,
};
